import { QueryParams } from '../types';
import api, {getAll, create, update, getOne, deleteOne, listAll} from './api';

const endpoint = '/files';

export default {
    all: async (params?: QueryParams) => getAll<any>({endpoint, params}),
    listAll: async () => listAll<any>({endpoint}),
    one: async (id: string, relations?: string) => getOne<any>({endpoint, id, relations}),
    destroy: async (id: string) => deleteOne({endpoint, id}),
    create: async (formData: Partial<any>) => create<any>({endpoint, formData}),
    update: async (id: string, formData: Partial<any>) => update<any>({ endpoint, formData, id }),
    async getProperties(id: string | undefined){
        try {
            const {data} = await api.get(endpoint+'/'+id+'/properties');
            return {data, isError: false};
        } catch (err: any) {
            return {
                data: err?.response?.data ?? {message: 'Falha ao processar requisição'},
                isError: true
            };
        }
    },
    async unlinkProperties(id: any, id_properties: any){
        try {
            const {data} = await api.put(endpoint+'/'+id+'/unlink-property', {id_properties: id_properties});
            return {data, isError: false};
        } catch (err: any) {
            return {
                data: err?.response?.data ?? {message: 'Falha ao processar requisição'},
                isError: true
            };
        }
    },

}